// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"footer_menu-item__PuRF4","footer":"footer_footer__4Qyt9","inner":"footer_inner__ZnSSe","wrapper":"footer_wrapper__vsYp1","footer-menu":"footer_footer-menu__cG5mD"};